import { render, staticRenderFns } from "./Action_transfer.vue?vue&type=template&id=71ba0c09&scoped=true"
import script from "./Action_transfer.vue?vue&type=script&lang=js"
export * from "./Action_transfer.vue?vue&type=script&lang=js"
import style0 from "./Action_transfer.vue?vue&type=style&index=0&id=71ba0c09&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba0c09",
  null
  
)

export default component.exports